import React, { ReactNode } from 'react';

type WorkspacePageProps = {
  children: ReactNode;
  className?: string;
};

/** Compact shell for backoffice page content inside MainLayout. */
export function WorkspacePage({ children, className = '' }: WorkspacePageProps) {
  return (
    <main className={`workspace-page min-w-0 max-w-full overflow-x-hidden ${className}`.trim()}>
      {children}
    </main>
  );
}

type WorkspacePageHeaderProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
};

export function WorkspacePageHeader({
  title,
  subtitle,
  actions,
  className = '',
}: WorkspacePageHeaderProps) {
  return (
    <header
      className={`workspace-page-header flex flex-wrap items-start justify-between gap-2 ${className}`.trim()}
    >
      <div className="min-w-0">
        <h1 className="workspace-page-title">{title}</h1>
        {subtitle ? <p className="workspace-page-subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </header>
  );
}

type WorkspacePanelProps = {
  children: ReactNode;
  className?: string;
};

export function WorkspacePanel({ children, className = '' }: WorkspacePanelProps) {
  return (
    <section className={`workspace-panel ${className}`.trim()}>
      {children}
    </section>
  );
}
